import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect } from "react";
import List from "@/components/List";
import InformationRow from "@/components/Row/InformationRow";
import NoContentMessage from "@/components/NoContentMessage";
import { useInformationsQuery } from "@/hooks";
import { LIST_PAGE_LIMIT } from "@/lib/constants";
import { jsx as _jsx } from "react/jsx-runtime";
export default function InformationsList(_ref) {
  let {
    id
  } = _ref;
  const _useInformationsQuery = useInformationsQuery({
      variables: {
        key: id,
        offset: 0,
        limit: LIST_PAGE_LIMIT
      }
    }),
    {
      data
    } = _useInformationsQuery,
    result = _objectWithoutProperties(_useInformationsQuery, _excluded);
  const items = data === null || data === void 0 ? void 0 : data.informations;
  useEffect(() => {
    var _items$data;
    if (items && items !== null && items !== void 0 && (_items$data = items.data) !== null && _items$data !== void 0 && _items$data[0]) {
      const latest = items.data[0];
      window.localStorage.setItem("latestInformation", latest.id);
      window.localStorage.setItem("currentInformarion", latest.id);
    }
  }, [items]);
  return /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({}, result), {}, {
    header: {
      text: "お知らせ一覧"
    },
    items: items,
    limit: LIST_PAGE_LIMIT,
    itemComponent: InformationRow,
    noContent: /*#__PURE__*/_jsx(NoContentMessage, {
      message: "\u304A\u77E5\u3089\u305B\u306F\u3042\u308A\u307E\u305B\u3093"
    }),
    viewTypeClassName: ""
  }));
}